/* jshint esnext: true */
import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor (options) {
        super(options);

        this.$body.addClass('has-alert');
        this.id = this.$el.attr('data-alert-id');
        this.$el.on('click.Alert', '.js-close', (event) => {
            this.closeAlert();
        });
    }

    closeAlert() {
        $.ajax({
            method: 'POST',
            url: 'close-alert',
            data: {
                id: this.id
            }
        })
        .done((response) => {
            if (response.success === true) {
                this.$body.removeClass('has-alert');
            } else {
                console.warn('Cookie could not be unset');
            }
        }).fail(() => {
            console.warn('Cookie could not be unset');
        });
    }

    destroy() {
        this.$el.off('.Alert');
    }
}
